import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchPageContent } from "../Layout/MainContent/DownloadAndDelete/actions";
import { checkAMLob } from "utils/checkAMLob";
import API, { setBaseURLForNonSecure } from "../../Services/API";

import RectangleLoader from "common-components/RectangleLoader";
import FallbackUI from "../Layout/MainContent/FallbackUI/FallbackUI";

const FetchPageContent = WrappedComponent => {
  const Wrapper = () =>
    class extends Component {
      state = {
        loadingAEMContent: true,
        errorFindingAEMContent: false
      };

      componentDidMount() {
        if (this.props.isNonSecure) {
          setBaseURLForNonSecure();
        }

        if (checkAMLob() === "agent") {
          API.defaults.baseURL =
            process.env.NODE_ENV === "production"
              ? "/privacy/secure/api/agent"
              : "http://localhost:8001/privacy/secure/api/agent";
        }

        const pageAlreadyFetched = this.props.fetchedPages ? this.props.fetchedPages.find(
          pageUrl => pageUrl === this.props.pageContentUrl
        ):"";
        

        if  (!pageAlreadyFetched) {
          this.props.fetchPageContent(this.props.pageContentUrl).then(() => {
            this.setState({
              loadingAEMContent: false
            });
          });
        } else {
          this.setState({ loadingAEMContent: false });
        }
      }

      render() {
        if (this.state.loadingAEMContent) {
          return <RectangleLoader />;
        }
        if (this.state.errorFindingAEMContent) {
          return <FallbackUI />;
        }
        return <WrappedComponent {...this.props} {...this.state} />;
      }
    };
  const mapStateToProps = ({ pageContent: { fetchedPages } }) => ({
    fetchedPages
  });
  return connect(
    mapStateToProps,
    { fetchPageContent }
  )(Wrapper());
};

export default FetchPageContent;
